export function addCurrent(security) {
  return {
      type: 'ADD_CURRENT',
      security,
  }
}